module.exports = __webpack_public_path__ + "fa44609af5c7b3563840a1bef91dcade.svg";